
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { AmazonMWSLinkedService } from 'app/model/linkedservice/amazon-mws.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'AmazonMWSObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AmazonMWS_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AmazonMWS_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AmazonMWSLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AmazonMWSObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
